import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import IconsCheck from "glesys-controlpanel/components/icons/check";

<template>
  <label
    class="grid grid-cols-[min-content_auto] gap-2 items-center has-enabled:cursor-pointer has-disabled:cursor-not-allowed"
  >
    <div class="grid [grid-template-areas:'checkbox'] *:[grid-area:checkbox]">
      <input
        class="opacity-0 peer enabled:cursor-pointer disabled:cursor-not-allowed"
        data-test-checkbox
        type="checkbox"
        {{mergeClasses}}
        ...attributes
      />
      <div class="bg-white border border-gray-200 size-4 inline-flex items-center justify-center" />
      <IconsCheck
        class="stroke-gray-500 size-4 transition-transform origin-bottom-left scale-0 peer-checked:scale-100"
      />
    </div>
    {{#if (has-block)}}
      <span class="text-gray-800 text-sm leading-tight">
        {{yield}}
      </span>
    {{/if}}
  </label>
</template>
